export const handleWait = async () => {
  await new Promise((resolve) => setTimeout(resolve, 500));
  return null;
};

